import { render, staticRenderFns } from "./RadioList.vue?vue&type=template&id=8b06b668&scoped=true&"
import script from "./RadioList.vue?vue&type=script&lang=ts&"
export * from "./RadioList.vue?vue&type=script&lang=ts&"
import style0 from "./RadioList.vue?vue&type=style&index=0&id=8b06b668&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b06b668",
  null
  
)

export default component.exports